<template lang="pug">
.content.question-content
  .row.question-body
    .col-md-12.col-md-header
      .header Danh sách câu hỏi
      .box-add-question(:style="$isMobile() ? 'float: none; margin-top: 0;' : ''")
        button.btn.btn-question-add(@click="onRouteAdd" :style="$isMobile() ? 'margin-bottom: 10px;' : ''") Thêm câu hỏi
      //- .clearfix
    .col-md-6.select-subject
      .form-group
        label.control-label Chọn môn học muốn xem *
        select#subject-id.form-control(@change="onChangeSubject($event)")
          //- option(value='') Chọn
          option(v-for='o in subjects' :value='o.id') {{o.name}}
      .clearfix
    .col-md-12.col-md-lst-question
      //- .card.card-lst-question
      //-   .card-content.card-content-lst-question
      //-     div(style='font-weight: bold;') LIST QUESTION PENDDING
      .box-table-question(v-on:scroll.passive='handleScroll' v-if="!$isMobile()")
        tbQuestion(
          @onfilterbyname="filterbyname",
          @onfilterbystatus="filterbystatus",
          @onItemDelete="onQuestionFormDelete",
          @onItemEdit="onQuestionFormEdit",
          @onLockAssistantItem="lockAssistantItem",
          @onFilterBlue="filterBlue",
          :lstStatus='lstStatus',
          :lstLevel='lstLevel',
          :lstFilter='lstFilter'
          :data='questions',
          :columns='columns',
          :inlineFilter='true'
        )
      .card.card-lst-question(v-else style="margin-top: 0;border-radius: 10px;")
        //- .card-content.card-content-lst-question
        //-   div(style='font-weight: bold;') LIST QUESTION PENDDING
        .row-header
          span.label-header Câu hỏi
          .field-header
            input(@change="filterbyname($event.target.value)" placeholder="Tìm theo nội dung câu hỏi lớn")
        .row-header.last
          span.label-header Trạng thái
          .field-header
            select(@change="filterbystatusX($event.target.value)")
              option( value='') Tất cả
              option(v-for='(o, i) in lstStatus' :value='o.key') {{o.value}}
        .list-action-all(v-if='questions.length > 0')
          small(@click="lockAssistantItem({data: null, type: 1})")
            .fas.fa-user-edit
          small(@click="lockAssistantItem({data: null, type: 2})")
            .fas.fa-user-lock
        .clearfix
        .empty-data(v-if='questions.length === 0') 
          span(style='font-weight:bold;') Không tìm thấy dữ liệu
        .list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='(item, index) in questions')
            .row-data
              .board-info
                span {{item.content_plain_text}}
            .row-data
              span.label-header Trạng thái:
              .row-value(:style="item.is_complete ? 'color:#3A9F00;' : 'color:#D63131;'") {{getDataValue(item.is_complete, 2)}}
            .row-data
              .filter-item
                span(:id="'categ_' + item.category_question.id" 
                  @click="filterItems(item.category_question.id, 1)"
                  :class="lstFilter.categories.includes(item.category_question.id) ? 'checked' : ''"
                ) {{item.category_question.name}}
                span(:id="'lv_' + item.level" 
                  @click="filterItems(item.level, 2)"
                  :class="lstFilter.level.includes(item.level) ? 'checked' : ''"
                ) {{getDataValue(item.level, 1)}}
                span(v-for="g in item.question_grade" 
                  :id="'grade_' + g.grade.id" 
                  @click="filterItems(g.grade.id, 3)"
                  :class="lstFilter.grades.includes(g.grade.id) ? 'checked' : ''"
                ) {{g.grade.name}}
            .row-data
              .action-buttons
                span.list-action
                  small(@click="collapseLines(item.id, true)" :class="'more-' + item.id")
                    img(:src="require('../../assets/images/theory/ic_moreinformation.svg')")
                  small.hidden(@click="collapseLines(item.id, false)" :class="'less-' + item.id")
                    img(:src="require('../../assets/images/theory/ic_lessinformation.svg')")
                span.list-action
                  small(@click="onQuestionFormEdit(item)")
                    img(:src="require('../../assets/images/faces/ic_edit.svg')")
                span.list-action
                  small(@click="onQuestionFormDelete(item)")
                    img(:src="require('../../assets/images/theory/delete-24px.svg')")
                span.list-action
                  small.support
                    .fas.fa-user-edit(v-if="!item.is_lock" style="color:#333333;" @click="lockAssistantItem({data: item, type: 3})")
                    .fas.fa-user-lock(v-else style="color:#333333;" @click="lockAssistantItem({data: item, type: 4})")
            .show-more.hidden(:class="'show-more-' + item.id")
              .row-data
                span.label-header Ngày tạo:
                .row-value {{formatDate(item.created_at)}}
              .row-data
                span.label-header Người tạo:
                .row-value {{item.userCreate.fullname}}
              .row-data
                span.label-header Ngày cập nhật:
                .row-value {{formatDate(item.updated_at)}}
              .row-data
                span.label-header Người cập nhật:
                .row-value {{item.userUpdate.fullname}}
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import tbQuestion from './tbQuestion'
import popupDeleteQuestion from './popupDelete'
import popupLockQuestion from './popupLock'
import jQuery from 'jquery'
import moment from 'moment'
export default {
  components: {
    jQuery,
    moment,
    tbQuestion,
    popupDeleteQuestion,
    popupLockQuestion
  },
  data() {
    return {
      offset: 0,
      limit: 10,
      subjects: [],
      questions: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'name', title: 'Câu hỏi', type: 'name' },
        { key: 'is_complete', title: 'Trạng thái', type: 'status' },
        { key: 'userCreate', title: 'Người tạo', type: 'created_user' },
        { key: 'created_at', title: 'Ngày tạo', type: 'date' },
        { key: 'userUpdate', title: 'Người cập nhật', type: 'created_user' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'action', title: '', type: 'action' }
      ],
      lstStatus: [
        {key: true, value: 'Hoàn thành'},
        {key: false, value: 'Chưa hoàn thành'}
      ],
      lstLevel: [
        {key: 1, value: 'Sơ cấp'},
        {key: 2, value: 'Trung cấp'},
        {key: 3, value: 'Cao cấp'}
      ],
      filtername: '',
      filterstatus: null,
      filtersubject: null,
      mobile: false,
      lstFilter: {
        categories: [],
        level: [],
        grades: []
      }
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onRouteAdd() {
      this.$router.push('/question_add')
    },
    getDataValue(key, type) {
      if (type === 1) {
        for (let i = 0; i < this.lstLevel.length; i++) {
          if (this.lstLevel[i].key === key) return this.lstLevel[i].value
        }
      } else if (type === 2) {
        for (let i = 0; i < this.lstStatus.length; i++) {
          if (this.lstStatus[i].key === key && key) {
            return this.lstStatus[i].value
          } else if (this.lstStatus[i].key === key && !key) {
            return this.lstStatus[i].value
          }
        }
      }
    },
    collapseLines(id, type) {
      if (type) {
        jQuery('.more-' + id).hide()
        jQuery('.less-' + id).show().removeClass('hidden').css('display', 'inline-block')
        // jQuery('.less-' + id)
        jQuery('.show-more-' + id).show().removeClass('hidden')
      } else {
        jQuery('.more-' + id).show()
        jQuery('.less-' + id).hide()
        jQuery('.show-more-' + id).hide()
      }
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    filterItems(id, type) {
      if (type === 1) {
        if (!this.lstFilter.categories.includes(id)) {
          this.lstFilter.categories.push(id)
        } else {
          this.lstFilter.categories.splice(this.lstFilter.categories.indexOf(id), 1)
        }
      } else if (type === 2) {
        if (!this.lstFilter.level.includes(id)) {
          this.lstFilter.level.push(id)
        } else {
          this.lstFilter.level.splice(this.lstFilter.level.indexOf(id), 1)
        }
      } else if (type === 3) {
        if (!this.lstFilter.grades.includes(id)) {
          this.lstFilter.grades.push(id)
        } else {
          this.lstFilter.grades.splice(this.lstFilter.grades.indexOf(id), 1)
        }
      }
      this.$apollo.queries.questions.refetch()
    },
    onChangeSubject(e) {
      let valueSubject = parseInt(e.target.value)
      this.filtersubject = this.subjects[0].id
      if (valueSubject !== null) {
        this.filtersubject = valueSubject
      }
      this.$apollo.queries.questions.refetch()
    },
    getSubjectDefalt() {
      if (this.subjects.length > 0) {
        this.filtersubject = this.subjects[0].id
      }
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.questions.length + 10
      }
    },
    filterbyname(valueName) {
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.$apollo.queries.questions.refetch()
    },
    filterbystatus(valueStatus) {
      this.filterstatus = null
      if (valueStatus === 0) {
        this.filterstatus = false
      } else if (valueStatus === 1) {
        this.filterstatus = true
      } else {
        this.filterstatus = null
      }
      this.$apollo.queries.questions.refetch()
    },
    onQuestionFormEdit(payload) {
      // console.log(payload)
      this.$router.push({name: 'question_edit', params: {id: payload.id}})
    },
    onQuestionFormDelete(payload) {
      this.$modal.show(popupDeleteQuestion, {
        id: payload.id,
        saveFunction: this.onItemDeleteParent
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        clickToClose: false
      })
    },
    async checkQuestionUsed(questionID) {
      if (questionID > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_COUNT_QUESTION_USED),
          variables: {
            where: {question_id: {_eq: questionID}}
          }
        })
        if (data.result_details_aggregate && data.result_details_aggregate.aggregate.count > 0) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    async onItemDeleteParent(payload) {
      // TODO: Đã có người làm câu hỏi này, không được xóa. (result_details model)
      var questionUsed = await this.checkQuestionUsed(payload.id)
      // let questionUsed = false
      if (!questionUsed) {
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_QUESTION),
          variables: {
            question_id: payload.id,
            changes: {
              is_delete: true
            }
          },
          update: (store, { data: { update_question } }) => {
            // Read the data from our cache for this query.
            // try {
            //   this.$apollo.queries.questions.refetch()
            // } catch (e) {
            //   console.error(e)
            // }
          }
        }).then((data) => {
          // Result
          this.$apollo.queries.questions.refetch()
          this.showNotification('Câu hỏi đã bị xóa', 'success', 'top', 'right', 7000)
        }).catch((error) => {
          // Error
          console.error(error)
        })
      } else {
        this.showNotification('Câu hỏi đang được sử dụng, không được xóa', 'danger', 'top', 'right', 7000)
      }
    },
    lockAssistantItem(payload) {
      if (payload.type === 1) {
        if (this.questions.length > 0) {
          this.$modal.show(popupLockQuestion, {
            title: 'MỞ KHOÁ CHỈNH SỬA CÂU HỎI',
            content: 'Bạn có muốn mở khoá chỉnh sửa tất cả câu hỏi hiện có không? Khi này bạn và các trợ lý sẽ có quyền chỉnh sửa nội dung câu hỏi.',
            type: payload.type,
            saveFunction: this.lockAllAssistantEdit
          }, {
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            clickToClose: false
          })
        }
      } else if (payload.type === 2) {
        if (this.questions.length > 0) {
          this.$modal.show(popupLockQuestion, {
            title: 'KHOÁ CHỈNH SỬA CÂU HỎI',
            content: 'Bạn có muốn khoá chỉnh sửa tất cả câu hỏi hiện có không? Khi này chỉ có bạn mới có thể chỉnh sửa được nội dung câu hỏi.',
            type: payload.type,
            saveFunction: this.lockAllAssistantEdit
          }, {
            height: 'auto',
            classes: ['col-6'],
            adaptive: true,
            clickToClose: false
          })
        }
      } else if (payload.type === 3) {
        // console.log(payload)
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_QUESTION),
          variables: {
            question_id: payload.data.id,
            changes: {
              is_lock: true
            }
          },
          update: (store, { data: { update_question } }) => {
            // Read the data from our cache for this query.
            try {
              this.$apollo.queries.questions.refetch()
            } catch (e) {
              console.error(e)
            }
          },
          error(error) {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
          }
        }).catch((error) => {
          // Error
          console.error(error)
        })
      } else if (payload.type === 4) {
        // console.log(payload)
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_QUESTION),
          variables: {
            question_id: payload.data.id,
            changes: {
              is_lock: false
            }
          },
          update: (store, { data: { update_question } }) => {
            // Read the data from our cache for this query.
            try {
              this.$apollo.queries.questions.refetch()
            } catch (e) {
              console.error(e)
            }
          },
          error(error) {
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
          }
        }).catch((error) => {
          // Error
          console.error(error)
        })
      }
    },
    async lockAllAssistantEdit(payload) {
      if (payload.type === 1) {
        for (let i = 0; i < this.questions.length; i++) {
          await this.$apollo.mutate({
            mutation: gql(graphql.UPDATE_QUESTION),
            variables: {
              question_id: this.questions[i].id,
              changes: {
                is_lock: false
              }
            },
            error(error) {
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
            }
          }).catch((error) => {
            // Error
            console.error(error)
          })
        }
        this.$apollo.queries.questions.refetch()
      } else {
        for (let i = 0; i < this.questions.length; i++) {
          await this.$apollo.mutate({
            mutation: gql(graphql.UPDATE_QUESTION),
            variables: {
              question_id: this.questions[i].id,
              changes: {
                is_lock: true
              }
            },
            error(error) {
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
            }
          }).catch((error) => {
            // Error
            console.error(error)
          })
        }
        this.$apollo.queries.questions.refetch()
      }
    },
    filterBlue(payload) {
      this.lstFilter.categories = payload.categories
      this.lstFilter.level = payload.level
      this.lstFilter.grades = payload.grades
    }
  },
  created() {},
  apollo: {
    questions: {
      query: gql(graphql.GET_QUESTION),
      fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          uid: this.$store.getters.user,
          limit: 10,
          order_by: {id: 'desc'}
        }
        if (this.filtername !== '') {
          variables = Object.assign(variables, {name: '%' + this.filtername + '%'})
        }
        variables = Object.assign(variables, {is_complete: this.filterstatus})
        if (this.filtersubject !== null) {
          variables = Object.assign(variables, {subject_id: this.filtersubject})
        } else {
          this.getSubjectDefalt()
          variables = Object.assign(variables, {subject_id: this.filtersubject})
        }
        if (this.lstFilter.level.length > 0) variables = Object.assign(variables, {levels: this.lstFilter.level})
        if (this.lstFilter.categories.length > 0) variables = Object.assign(variables, {categ_ids: this.lstFilter.categories})
        if (this.lstFilter.grades.length > 0) variables = Object.assign(variables, {grade_ids: this.lstFilter.grades})
        return variables
      },
      update: data => {
        // let grade = []
        for (let i = 0; i < data.question.length; i++) {
          data.question[i].stt = i + 1
          data.question[i].name = '<span>[ID: ' + data.question[i].id + ']</span> ' + data.question[i].content_plain_text
          data.question[i].content_plain_text = '[ID: ' + data.question[i].id + '] ' + data.question[i].content_plain_text
        }
        // console.log(data.question)
        return data.question
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      // fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-content {
  .question-body {
    .col-md-header {
      margin-bottom: 0px;
    }
    .header {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #5F6468;
      display: inline-block;
    }
    .box-add-question {
      float: right;
      margin-top: -10px;
      .btn-question-add {
        background-color: #FFD311;
        width: 214px;
        height: 48px;
        border-radius: 5px;
        color: black;
        text-transform: none;
        font-size: 14px;
        font-family: 'adobe-clean' sans-serif;
        border: 1px solid #FFD311;
        padding: 0;
        margin-bottom: 0;
        &:active {
          background-color: #CCAD7B;
          color: black;
        }
      }
    }
    .select-subject {
      // padding-right: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        margin-top: 0;
        input, select {background-color: white;}
      }
    }
    .col-md-lst-question {
      // .card-lst-question {
      //   border-radius: 10px;
      //   margin-top: 0;
      //   .card-content-lst-question {}
      // }
      .box-table-question {
        background: white;
        box-shadow: 0px 1px 3px #00000029;
        padding: 10px;
        max-height: 385px; 
        overflow-y: scroll;
        border-radius: 10px;
      }
    }
  }
}
@media (max-width: 414px) {
  .card-lst-question {background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{
        display: inline-block; line-height: 30px;width: 30%;font-weight: bold;text-align: right; padding-right: 10px;
      }
      .field-header{padding: 5px 10px; display: inline-block; width: 70%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}
      }
      &:first-child{border-top: 1px solid #E0E0E0;border-top-left-radius: 10px;border-top-right-radius: 10px; overflow: hidden;}
      &.last{border-bottom-left-radius: 10px !important;border-bottom-right-radius: 10px !important;overflow: hidden;}
    }
    .list-action-all {
      float: right;
      margin-top: 9px;
      small {
        &:nth-child(2n) {margin-right: 0;}
      }
      small{width: 16px; height: 16px; margin-right: 10px; display: inline-block;
        .fas {cursor: pointer;}
        .fa-user-edit {color: #3A9F00;}
        .fa-user-lock {color: #D63131;}
      }
    }
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; text-align: center; padding: 5px;}
    .list-item{margin-top: 9px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; padding: 7px 5px;margin-bottom: 10px;
        &:first-child{margin-bottom: 10px;}
        &:last-child {margin-bottom: 0;}
        .show-more {
          .row-data {
            .row-value {color: #343A40;}
            &:last-child {
              .row-value {padding-bottom: 0;}
            }
          }
        }
        .row-data{
          .label-header{display: inline-block;text-align: left; padding-right: 8px; color: #969FAD;}
          .row-value{padding-bottom: 8px; display: inline-block;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
          }
          .board-info{ width: 100%; display: inline-flex; height: 60px; overflow: hidden; text-overflow: ellipsis; margin-bottom: 8px;
            span{font-size: 15px; font-weight: bold; display: block; color: #9F6A28;}
          }
          .filter-item {
            span {
              padding: 4px 8px; 
              background: #F2F2F2; 
              border-radius: 10px; 
              color: #969FAD; 
              box-shadow: 0px 1px 3px #00000029; 
              margin: 0 8px 8px 0;
              cursor: pointer;
              display: inline-block;
              &.checked {
                background: #219AFF; 
                color: white;
              }
            }
          }
          .action-buttons {
            text-align: right;
            margin-bottom: 8px;
            .list-action {
              small{width: 16px; height: 16px; margin-right: 16px; display: inline-block;
                &.support {margin-right: 8px;}
                img{max-width: 100%; height: auto; cursor: pointer;}
                .fas {cursor: pointer;}
                .ic-public {font-size: 16px;  color: #333333; vertical-align: text-bottom;}
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7e8c06c5